import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    component: () => import('../components/404.vue')
  },

  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/sign_up',
    name: 'Record',
    component: () => import('../views/Record.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contacts.vue')
  },
  {
    path: '/successful_entry',
    name: 'SuccessfulEntry',
    component: () => import('../views/SuccessfulEntry.vue')
  },
  {
    path: '/rules',
    name: 'Rules',
    component: () => import('../views/Rules.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (!savedPosition) {
      scrollTo({top: 0});
    }
  },
  routes,
})

export default router
